import _ from 'lodash';
import moment from 'moment';
import type { RaterXPreset } from '../../api/types/rater-x-preset';
import type { EditQuoteState } from '../../views/edit-quote/types';
import type { UnderwriteQuoteState } from '../../views/underwriter/types';

export function mergeGlobalsFromQuote(
  quote: EditQuoteState['quote']['quote'],
  raterXGlobals: RaterXPreset['global']
) {
  const globalValues = _.pick(quote, [
    'aggLimit',
    'deductible',
    'waitingPeriod',
    'retroactivePeriod',
    'retroactiveDate',
  ]);

  Object.keys(globalValues).forEach((key) => {
    const _path = GLOBAL_VAL_PATHS[key as keyof typeof GLOBAL_VAL_PATHS];
    let _value = globalValues[key as keyof typeof globalValues];

    if (_value) {
      if (_path.includes('retroactive')) {
        _.unset(raterXGlobals, 'value.props.retroactive.props');
      }
      if (key === 'retroactiveDate') {
        _value = moment.utc(_value).format('YYYY-MM-DD');
      }
      _.set(raterXGlobals, _path, _value);
    }
  });

  return raterXGlobals;
}

const mergeQuoteGlobalsIntoState = <
  T extends EditQuoteState & Partial<UnderwriteQuoteState>
>(
  data: T
) => {
  const global = mergeGlobalsFromQuote(data.quote.quote, data.raterX.global);

  return {
    ...data,
    global,
  };
};

export default mergeQuoteGlobalsIntoState;

const GLOBAL_VAL_PATHS = {
  aggLimit: 'value.props.limit.value',
  deductible: 'value.props.deductible.value',
  waitingPeriod: 'value.props.waitingPeriod.value',
  retroactivePeriod: 'value.props.retroactive.props.period.value',
  retroactiveDate: 'value.props.retroactive.props.date.value',
};
